import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/MobileExperienceIllustration.tsx
const MobileExperienceIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "mobile-experience.svg",
		alt: t("illustration.imageAlt.mobileExperience")
	});
};

//#endregion
export { MobileExperienceIllustration };